module.exports = __webpack_public_path__ + "static/img/zcgl-bg.0b7be46.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/zcgl-bg.png
// module id = Ax/d
// module chunks = 96